module.exports = __webpack_public_path__ + "img/icon-purple-clock.76fe3d73.svg";